<template>
  <v-autocomplete
    v-model="selected"
    variant="underlined"
    :items="list"
    item-title="fullLabel"
    item-value="clientId"
    label="Fields"
    hide-no-data
    return-object
    hide-selected
    clearable
    required
    :rules="requiredRules"
    :filter="customFilter"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'QuestionChooser',
  props: {
    question: Object,
    list: Array,
    modelValue: String
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selected: this.question || undefined,
      requiredRules: [v => !!v || 'Required']
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  },
  watch: {
    selected(newValue) {
      this.$emit('onSelect', newValue)
      this.$emit('update:modelValue', newValue ? newValue.clientId : '')
    }
  }
}
</script>
